var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70711 15.7071C6.31658 16.0976 5.68342 16.0976 5.29289 15.7071C4.90237 15.3166 4.90237 14.6834 5.29289 14.2929L11.2929 8.29289C11.6715 7.91432 12.2811 7.90107 12.6757 8.26285L18.6757 13.7628C19.0828 14.136 19.1103 14.7686 18.7372 15.1757C18.364 15.5828 17.7314 15.6103 17.3243 15.2372L12.0301 10.3841L6.70711 15.7071Z",
    fill: "#34657F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownBlueIcon);
export default __webpack_public_path__ + "static/media/arrow-down-blue-icon.7a4d13358e1dea959a7b4646eb38941c.svg";
export { ForwardRef as ReactComponent };